
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { useLanguage } from '@/hooks/useLanguage';

interface ContactSectionProps {
  form: UseFormReturn<any>;
  isLoading: boolean;
}

const ContactSection: React.FC<ContactSectionProps> = ({ form, isLoading }) => {
  const { translate } = useLanguage();

  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle>{translate('subscriptions.contactInformation')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FormField
            control={form.control}
            name="contact_name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate('subscriptions.contactName')}</FormLabel>
                <FormControl>
                  <Input 
                    placeholder={translate('subscriptions.contactName')} 
                    disabled={isLoading} 
                    {...field} 
                    value={field.value || ''}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="contact_email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate('subscriptions.contactEmail')}</FormLabel>
                <FormControl>
                  <Input 
                    type="email" 
                    placeholder={translate('subscriptions.contactEmail')} 
                    disabled={isLoading} 
                    {...field} 
                    value={field.value || ''}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="contact_phone"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate('subscriptions.contactPhone')}</FormLabel>
                <FormControl>
                  <Input 
                    placeholder={translate('subscriptions.contactPhone')} 
                    disabled={isLoading} 
                    {...field} 
                    value={field.value || ''}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ContactSection;
